import { createFileRoute, Outlet } from '@tanstack/react-router';

import { buildOrgLoginOptions } from '../../../components/shared/utilities/appUtilities';

export const Route = createFileRoute('/_public/signup/')({
  component: Outlet,
  beforeLoad: async ({ context: { auth0 } }) => {
    const { loginWithRedirect } = auth0;
    const defaultReturnTo = '/';

    const loginOpts = buildOrgLoginOptions({
      appState: {
        returnTo: defaultReturnTo,
      },
    });

    // TODO 9/24/25: Figure out a more elegant way to handle this now that app id is gone
    // if (!auth0?.user) {
    //   if (appId === 'tax-preparer') {
    //     window.location.href = 'https://ledgible.io/crypto-tax-pro-signup/';
    //   }

    //   if (appId === 'tir-admin') {
    //     window.location.href =
    //       'https://ledgible.io/contact/?multi_select=Tax%20Information%20Reporting';
    //   }

    //   if (appId === 'accounting') {
    //     window.location.href =
    //       'https://ledgible.io/contact/?multi_select=Digital%20Asset%20Accounting';
    //   }

    //   if (appId === 'tax') {
    //     loginWithRedirect(loginOpts);
    //   }
    // } else {
    loginWithRedirect(loginOpts);
    // }
  },
});
